import { useMemo } from 'react'

// @ts-expect-error - not typed
import { Label } from '@scoir/tabs'

import FwdRefNavLink from 'components/FwdRefNavLink'

import { DISPLAY_ORDER, TABS, getIcon } from './outreach-tabs'

const getTabConfiguration = (url: string, page: string) => {
  const tab = TABS[page as keyof typeof TABS]
  const value = tab.value
  const to = tab.getUrl(url)
  const text = tab.text
  const icons = tab.icons

  const tabConfiguration = (data = 0, currentPage: string) => {
    const active = page === currentPage
    const location = window.location
    const currentUrl = location.pathname + location.search
    const icon = icons ? getIcon(icons, active) : null
    const actualTo = active ? currentUrl : to

    return {
      to: actualTo,
      value,
      component: FwdRefNavLink,
      labelText: text,
      'aria-label': 'Click to view ' + text,
      label: (
        <Label
          icon={icon}
          count={data}
        >
          {text}
        </Label>
      ),
    }
  }

  return tabConfiguration
}

export const useOutreachTabs = (url: string) => {
  const tabs = useMemo(() => {
    return DISPLAY_ORDER.map((page) => {
      return getTabConfiguration(url, page)
    })
  }, [url])
  return tabs
}
